import { BaseLogicExpression } from "../Logic/BaseLogic";
import { ExpressionValue } from "../../ExpressionValue";
import { DateDataDefinition } from "../../../Common/Data/Definitions/DateDataDefinition";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class DateEqualToExpression extends BaseLogicExpression {
    readonly __type: string = "Date Equal To";
    readonly __ruleName: string = "Equals";

    value1: ExpressionValue;
    value2: ExpressionValue;

    constructor() {
        super();
        this.value1 = ExpressionValue.createExpressionValue(this, "value1", new DateDataDefinition());
        this.value2 = ExpressionValue.createExpressionValue(this, "value2", new DateDataDefinition());
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return (
            this.value1.evaluate(data, testContext).getTime() - this.value2.evaluate(data, testContext).getTime() === 0
        );
    }
}
